import type { LottieProps } from "react-lottie-player";
import Lottie from "react-lottie-player";

import pageLoadingLottie from "./pageLoading.json";

export function PageLoadingLottie(props: LottieProps) {
  return (
    <Lottie
      className="h-[140px] w-[165px]"
      animationData={pageLoadingLottie}
      loop
      play
      {...props}
    />
  );
}
